<template>
  <div class="col-lg-6 col-md-9 statbox statbox-gauge mb-4 clear">
    <div>
      <div class="box">
        <span class="title widget-title" v-html="widget.attributes.title.attributeValue"></span>
      </div>      
      <div class="gauge row">
        <div v-for="index in [0,1,2]" :key="index" :class="'gauge_' + index + ' col-md-4'">
          <gauge :settings="options[index]" :value="data['LAST_' + index]"></gauge>
        </div>      
      </div>
      <div>
        <div>
          <div><!--15:48:05--></div>
          <div><!--31/05/2019--></div>
        </div>
        <div>
          <a @click.prevent="openChart" class="eye">
            <img src="/assets/img/png/eye.png" alt="show-chart"/>
          </a>
        </div>
      </div>
    </div>
    <overlay :enabled="loading"></overlay>
  </div>
</template>

<script>
  import moment from 'moment'
  import notificator from '@/mixins/notificator';

  import Gauge from '../Charts/Gauge.vue';
  import Overlay from '@/components/Overlay.vue';

  export default {
    props: ['widget'],
    
    components: {Overlay, Gauge},

    mixins: [notificator],
      
    data() {
      return {
        ready: false,
        loading: false,
        timer: null,

        data: {
          'LAST_0': {},
          'LAST_1': {},
          'LAST_2': {}
        },

        options: {
          '0': {},
          '1': {},
          '2': {},
        }
      }
    },

    created() {   
      for (let index = 0; index <= 2; index++) {

        this.$set(this.options, index, {
          chart: {
            type: 'solidgauge',
            height: 180,
            // height: '70%',
            //  width: 300
          },
          title: {
            text: this.widget.attributes['paramDescription' + (index + 1)].attributeValue,
            style: {
              color: 'rgba(51, 51, 51, 0.8)',
              fontWeight: 'bold',
              fontFamily: 'Rubik'
              
            }
          },
          pane: {
            center: ["50%", "70%"],
            size: "140%",
            startAngle: -90,
            endAngle: 90,
            background: {
              // backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || "#EEE",
              backgroundColor: "#EEE",
              innerRadius: "60%",
              outerRadius: "100%",
              shape: "arc"
            }
          },
          exporting: {enabled: false},
          tooltip: {enabled: false},
          credits: {enabled: false},
          yAxis: {
            min: parseInt(this.widget.attributes.minRangeValue.attributeValue),
            max: parseInt(this.widget.attributes.maxRangeValue.attributeValue),
            stops: [
                [this.widget.attributes.thresholdBand1.attributeValue, this.widget.attributes.colorBand1.attributeValue],
                [this.widget.attributes.thresholdBand2.attributeValue, this.widget.attributes.colorBand2.attributeValue],
                [this.widget.attributes.thresholdBand3.attributeValue, this.widget.attributes.colorBand3.attributeValue]
            ],
            lineWidth: 0,
            minorTickInterval: null,
            tickPixelInterval: 400,
            tickWidth: 0,
            title: {
              y: -70,
            },
            labels: {
              y: 16,            
              style: {
                color: 'rgba(51, 51, 51, 0.8)',
                fontWeight: 'bold',
                fontFamily: 'Rubik',
                fontSize: '14px' 
              }
            }
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: -30,
                borderWidth: 0,
                useHTML: true,
                style: {
                  color: 'rgba(51, 51, 51, 0.8)',
                  fontWeight: 'bold',
                  fontFamily: 'Rubik',
                  fontSize: '16px'                  
                }
              }
            }
          },
          series: [{
            name: "",
            data: [],
            tooltip: {
              valueSuffix: this.widget.attributes.unit.attributeValue
            }
          }]
        });                           
      }      
      
      this.start();
    },
      
    methods: {
      start() {
        this.getTSData()

        this.timer = setInterval(() => {
            this.getTSData()
        }, 60000);
      },

      generateDevicesQueries() {
        var offset = new Date().getTimezoneOffset();
        
        var aqDatetimeLowerbound = moment().subtract(1, 'days').add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';
        var aqDatetimeUpperbound = moment().add(offset, 'minutes').format('YYYY-MM-DD') + 'T' + moment().add(offset, 'minutes').format('HH:mm:ss') + 'Z';

        var devicesQueries = [];

        for (let index = 0; index <= 2; index++) {
          devicesQueries.push({
            'aggregation': {'mode': 'LAST'},
            'aqDatetimeLowerbound': aqDatetimeLowerbound,
            'aqDatetimeUpperbound': aqDatetimeUpperbound,
            'deviceIds': [this.widget.deviceId], 
            'paramIds': [parseInt(this.widget.attributes['paramId' + (index + 1)].attributeValue)],
            'queryId': 'LAST_' + index,
            'readingType': this.widget.attributes.readingType.attributeValue
          });
        }
        
        return devicesQueries;
      },

      getTSData() {

        if(!this.ready)
          this.overlay(true);

        this.$store
          .dispatch('getTSData', {devicesQueries: this.generateDevicesQueries()})
          .catch(error => {
            if(!this.ready)
              this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: error}));            

            this.data = {};

            if(!this.ready)
                this.ready = true;
          })
          .then(({data}) => {
            if(!this.ready)
              this.overlay(false);

            this.notify(this.$options.filters.notification({endpoint: 'GetTSData', code: 200}));

            if(data != undefined && data.deviceQueriesResponse != undefined) {
              for (let index = 0; index <= 2; index++) {
                if(data.deviceQueriesResponse['LAST_' + index] != undefined && data.deviceQueriesResponse['LAST_' + index][0] != undefined)
                  this.data['LAST_' + index] = data.deviceQueriesResponse['LAST_' + index][0];
                else
                  this.data['LAST_' + index] = {};                  
              }              
            }
            
            if(!this.ready)
              this.ready = true;
        });          
      },
        
      overlay(action) {
        this.loading = action;
      },

      openChart() {
          this.$emit('open-chart', this.widget);
      }
    },

    beforeDestroy: function(){
      clearInterval(this.timer);
    }
  }
</script>